import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';

import { logout } from '../auth/duck';

class Logout extends React.Component {
  handleLogout = () => {
    this.props.logout();
    this.props.history.push('/login');
  };

  render() {
    const { t, title } = this.props;

    return (
      <button
        onClick={this.handleLogout}
        className="c-btn c-btn--logout c-btn--effect"
      >
        {title || t('general.logout')}
      </button>
    );
  }
}

const mapDispatchToProps = { logout };

export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(translate()(Logout))
);



// WEBPACK FOOTER //
// ./src/common/Logout.js